import { preloadedScenes } from 'scenes/scenes'
import { Scene } from 'scenes/sceneTypes'

import { productScenes } from '~/productScenes'

export const appScenes: Record<Scene | string, () => any> = {
    ...productScenes,
    [Scene.AdvancedActivityLogs]: () => import('./audit-logs/AdvancedActivityLogsScene'),
    [Scene.AgenticAuthorize]: () => import('./agentic/AgenticAuthorize'),
    [Scene.Approval]: () => import('./approvals/ApprovalDetail'),
    [Scene.AsyncMigrations]: () => import('./instance/AsyncMigrations/AsyncMigrations'),
    [Scene.MaterializedColumns]: () => import('./data-management/MaterializedColumns/MaterializedColumns'),
    [Scene.BatchExportNew]: () => import('./data-pipelines/batch-exports/BatchExportScene'),
    [Scene.BatchExport]: () => import('./data-pipelines/batch-exports/BatchExportScene'),
    [Scene.BillingAuthorizationStatus]: () => import('./billing/AuthorizationStatus'),
    [Scene.BillingSection]: () => import('./billing/BillingSection'),
    [Scene.Billing]: () => import('./billing/Billing'),
    [Scene.Canvas]: () => import('./notebooks/NotebookCanvasScene'),
    [Scene.CLIAuthorize]: () => import('./authentication/cli/CLIAuthorize'),
    [Scene.CLILive]: () => import('./authentication/cli/CLILive'),
    [Scene.Cohort]: () => import('./cohorts/Cohort'),
    [Scene.CohortCalculationHistory]: () => import('./cohorts/CohortCalculationHistory'),
    [Scene.Cohorts]: () => import('./cohorts/Cohorts'),
    [Scene.CustomCss]: () => import('./themes/CustomCssScene'),
    [Scene.Dashboard]: () => import('./dashboard/Dashboard'),
    [Scene.Dashboards]: () => import('./dashboard/dashboards/Dashboards'),
    [Scene.DataManagement]: () => import('./data-management/DataManagementScene'),
    [Scene.DataPipelinesNew]: () => import('./data-pipelines/DataPipelinesNewScene'),
    [Scene.DataOps]: () => import('./data-warehouse/DataWarehouseScene'),
    [Scene.DeadLetterQueue]: () => import('./instance/DeadLetterQueue/DeadLetterQueue'),
    [Scene.QueryPerformance]: () => import('./instance/QueryPerformance/QueryPerformance'),
    [Scene.Destinations]: () => import('./data-pipelines/DestinationsScene'),
    [Scene.DebugHog]: () => import('./debug/hog/HogRepl'),
    [Scene.DebugQuery]: () => import('./debug/DebugScene'),

    [Scene.Error404]: () => ({ default: preloadedScenes[Scene.Error404].component }),
    [Scene.ErrorNetwork]: () => ({ default: preloadedScenes[Scene.ErrorNetwork].component }),
    [Scene.ErrorProjectUnavailable]: () => ({ default: preloadedScenes[Scene.ErrorProjectUnavailable].component }),
    [Scene.EventDefinitionEdit]: () => import('./data-management/definition/DefinitionEdit'),
    [Scene.EventDefinition]: () => import('./data-management/definition/DefinitionView'),
    [Scene.Experiment]: () => import('./experiments/Experiment'),
    [Scene.ExperimentsSharedMetric]: () => import('./experiments/SharedMetrics/SharedMetric'),
    [Scene.ExperimentsSharedMetrics]: () => import('./experiments/SharedMetrics/SharedMetrics'),
    [Scene.Experiments]: () => import('./experiments/Experiments'),
    [Scene.ExploreEvents]: () => import('./activity/explore/EventsScene'),
    [Scene.ExploreSessions]: () => import('./activity/explore/SessionsScene'),
    [Scene.FeatureFlag]: () => import('./feature-flags/FeatureFlag'),
    [Scene.FeatureFlags]: () => import('./feature-flags/FeatureFlags'),
    [Scene.Group]: () => import('./groups/Group'),
    [Scene.GroupsNew]: () => import('./groups/GroupsNew'),
    [Scene.Groups]: () => import('./groups/Groups'),
    [Scene.HogFunction]: () => import('./hog-functions/HogFunctionScene'),
    [Scene.Insight]: () => import('./insights/InsightScene'),
    [Scene.InsightQuickStart]: () => import('./insights/InsightQuickStart/InsightQuickStart'),
    [Scene.IntegrationsRedirect]: () => import('./IntegrationsRedirect/IntegrationsRedirect'),
    [Scene.IntegrationsLanding]: () => import('./integrations/IntegrationsLandingScene'),
    [Scene.StripeConfirmInstall]: () => import('./StripeConfirmInstall/StripeConfirmInstall'),
    [Scene.InviteSignup]: () => import('./authentication/invite-signup/InviteSignup'),
    [Scene.LegacyPlugin]: () => import('./data-pipelines/legacy-plugins/LegacyPluginScene'),
    [Scene.Coupons]: () => import('./coupons/Coupons'),
    [Scene.LiveEvents]: () => import('./activity/live/LiveEventsTable'),
    [Scene.Login2FA]: () => import('./authentication/login-2fa/Login2FA'),
    [Scene.Login]: () => import('./authentication/login/Login'),
    [Scene.MarketingAnalytics]: () => import('./marketing-analytics/MarketingAnalyticsScene'),
    [Scene.Max]: () => import('./max/Max'),
    [Scene.Models]: () => import('./models/ModelsScene'),
    [Scene.MoveToPostHogCloud]: () => import('./moveToPostHogCloud/MoveToPostHogCloud'),
    [Scene.NewTab]: () => import('./new-tab/NewTabScene'),
    [Scene.Notebook]: () => import('./notebooks/NotebookScene'),
    [Scene.Notebooks]: () => import('./notebooks/NotebooksScene'),
    [Scene.OAuthAuthorize]: () => import('./oauth/OAuthAuthorize'),
    [Scene.Onboarding]: () => import('./onboarding/Onboarding'),
    [Scene.OnboardingCoupon]: () => import('./onboarding/legacy/coupon/OnboardingCouponRedemption'),
    [Scene.OrganizationCreateFirst]: () => import('./organization/Create'),
    [Scene.OrganizationCreationConfirm]: () => import('./organization/ConfirmOrganization/ConfirmOrganization'),
    [Scene.PasswordResetComplete]: () => import('./authentication/password-reset/PasswordResetComplete'),
    [Scene.AccountConnected]: () => import('./authentication/account/AccountConnected'),
    [Scene.CredentialReview]: () => import('./authentication/account/credential-review/CredentialReview'),
    [Scene.PasswordReset]: () => import('./authentication/password-reset/PasswordReset'),
    [Scene.TwoFactorReset]: () => import('./authentication/two-factor-reset/TwoFactorReset'),
    [Scene.Person]: () => import('./persons/PersonScene'),
    [Scene.Persons]: () => import('./persons/PersonsScene'),
    [Scene.PreflightCheck]: () => import('./PreflightCheck/PreflightCheck'),
    [Scene.ProjectCreateFirst]: () => import('./project/Create'),
    [Scene.ProjectHomepage]: () => import('./project-homepage/ProjectHomepage'),
    [Scene.PropertyDefinitionEdit]: () => import('./data-management/definition/DefinitionEdit'),
    [Scene.PropertyDefinition]: () => import('./data-management/definition/DefinitionView'),
    [Scene.SqlVariableEdit]: () => import('./data-management/variables/SqlVariableEditScene'),
    [Scene.ReplayFilePlayback]: () => import('./session-recordings/file-playback/SessionRecordingFilePlaybackScene'),
    [Scene.ReplayPlaylist]: () => import('./session-recordings/playlist/SessionRecordingsPlaylistScene'),
    [Scene.ReplaySettings]: () => import('./session-recordings/settings/SessionRecordingsSettingsScene'),
    [Scene.ReplaySingle]: () => import('./session-recordings/detail/SessionRecordingDetail'),
    [Scene.ReplayKiosk]: () => import('./session-recordings/kiosk/SessionRecordingsKiosk'),
    [Scene.Replay]: () => import('./session-recordings/SessionRecordings'),
    [Scene.ResourceTransfer]: () => import('./resource-transfer/ResourceTransfer'),
    [Scene.DashboardTemplateCopy]: () => import('./dashboard/dashboards/templates/DashboardTemplateCopyScene'),
    [Scene.SQLEditor]: () => import('./data-warehouse/editor/EditorScene'),
    [Scene.SavedInsights]: () => import('./saved-insights/SavedInsights'),
    [Scene.WebScripts]: () => import('./data-pipelines/WebScriptsScene'),
    [Scene.Health]: () => import('./health/HealthScene'),
    [Scene.HealthCategoryDetail]: () => import('./health/categoryDetail/HealthCategoryDetailScene'),
    [Scene.HealthAlerts]: () => import('./health-alerts/HealthAlertsScene'),
    [Scene.PipelineStatus]: () => import('./health/pipelineStatus/PipelineStatusScene'),
    [Scene.SdkHealth]: () => import('./onboarding/shared/sdkHealth/SdkHealthScene'),
    [Scene.Exports]: () => import('./exports/ExportsScene'),
    [Scene.SessionAttributionExplorer]: () =>
        import('scenes/web-analytics/SessionAttributionExplorer/SessionAttributionExplorerScene'),
    [Scene.SessionProfile]: () => import('./sessions/SessionProfileScene'),
    [Scene.Settings]: () => import('./settings/SettingsScene'),
    [Scene.Signup]: () => import('./authentication/signup/SignupContainer'),
    [Scene.Site]: () => import('./sites/Site'),
    [Scene.StartupProgram]: () => import('./startups/StartupProgram'),
    [Scene.Survey]: () => import('./surveys/Survey'),
    [Scene.SurveyWizard]: () => import('./surveys/wizard/SurveyWizard'),
    [Scene.SurveyFormBuilder]: () => import('./surveys/forms/SurveyFormBuilder'),
    [Scene.Surveys]: () => import('./surveys/Surveys'),
    [Scene.ProductTours]: () => import('./product-tours/ProductTours'),
    [Scene.ProductTour]: () => import('./product-tours/ProductTour'),
    [Scene.SystemStatus]: () => import('./instance/SystemStatus'),
    [Scene.ToolbarLaunch]: () => import('./toolbar-launch/ToolbarLaunch'),
    [Scene.Transformations]: () => import('./data-pipelines/TransformationsScene'),
    [Scene.EventFiltering]: () => import('./data-pipelines/event-filtering/EventFilterScene'),
    [Scene.Unsubscribe]: () => import('./Unsubscribe/Unsubscribe'),
    [Scene.CodeCanvasLink]: () => import('./code-canvas/CodeCanvasLink'),
    [Scene.CodeChannelLink]: () => import('./code-canvas/CodeChannelLink'),
    [Scene.VercelConnect]: () => import('./authentication/vercel/VercelConnect'),
    [Scene.VercelLinkError]: () => import('./authentication/vercel/VercelLinkError'),
    [Scene.AgenticAccountMismatch]: () => import('./authentication/account/AgenticAccountMismatch'),
    [Scene.VerifyEmail]: () => import('./authentication/verify-email/VerifyEmail'),
    [Scene.WebAnalyticsWebVitals]: () => import('./web-analytics/WebAnalyticsScene'),
    [Scene.WebAnalyticsHealth]: () => import('./web-analytics/WebAnalyticsScene'),
    [Scene.WebAnalyticsLive]: () => import('./web-analytics/WebAnalyticsScene'),
    [Scene.WebAnalyticsRecap]: () => import('./web-analytics/recap/WebAnalyticsRecapScene'),
    [Scene.WebAnalytics]: () => import('./web-analytics/WebAnalyticsScene'),
    [Scene.Wizard]: () => import('./wizard/Wizard'),
    [Scene.OrganizationDeactivated]: () => import('./organization/Deactivated'),
    [Scene.OrganizationPendingDeletion]: () => import('./organization/PendingDeletion'),
    [Scene.ProjectPendingDeletion]: () => import('./project/PendingDeletion'),
}
